<template>
  <div class="about">
    <b-tabs type="is-boxed" horizontal expanded>
      <b-tab-item label="Add a New Product" icon="plus">
        <div>
          <input type="file" @change="previewImage" accept="image/*" />
        </div>
        <div>
          <p>
            Progress: {{uploadValue.toFixed()+"%"}}
            <progress
              id="progress"
              :value="uploadValue"
              max="100"
            ></progress>
          </p>
        </div>
        <div v-if="imageData!=null">
          <img class="preview" :src="picture" />
          <br />
          <button @click="onUpload">Upload</button>
        </div>
        <b-message type="is-danger" v-if="error">{{ error }}</b-message>
        <b-field label="Product Name">
          <b-input v-model="name" rounded></b-input>
        </b-field>
        <br />
        <b-field label="Product Description">
          <v-textarea outlined v-model="description" name="input-7-3"></v-textarea>
        </b-field>
        <br />
        <b-field label="Product Price">
          <b-numberinput v-model="price" type="number" rounded></b-numberinput>
        </b-field>
        <br />
        <v-btn class="ma-2" :loading="loading" :disabled="loading" @click="Add()">ADD PRODUCT</v-btn>
      </b-tab-item>

      <b-tab-item label="Order Requests" icon="cart">
        <div v-for="item in order" class='order' :key="item.id">
          <v-card class="orders">
            {{item.email}} ordered {{order.length}} products which include
            {{item.cartItemList}}
            which is a total of ₦{{item.total}}.00
          </v-card>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      name: "",
      description: "",
      price: 0,
      error: null,
      order: []
    };
  },
  methods: {
    Add() {
      this.loading = true;
      this.$fb.database
        .collection("Product")
        .add({
          name: this.name,
          description: this.description,
          price: this.price,
          slug: this.generateUUID(),
          picture: this.picture
        })
        .then(() => {
          this.name = "";
          this.description = "";
          this.price = 0;
          this.picture = null;
        })
        .catch(error => {
          this.error = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateUUID() {
      let d = new Date().getTime();
      let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          let r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    },

    onUpload() {
      this.picture = null;
      const storageRef = this.$fb.storage
        .ref(`${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.picture = url;
          });
        }
      );
    }
  },
  mounted() {
    this.$fb.database
      .collection("order")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.loading = true;
          let data = {
            cartItemList: doc.data().cartItemList,
            email: doc.data().email,
            total: doc.data().total
          };
          this.order.push(data);
          this.loading = false;
        });
      });
  }
};
</script>
<style>
.orders {
  width: 100%;
}
.ma-2 {
  color: green;
}
img.preview {
  width: 200px;
}
.about {
  width: 100%;
  margin-top: 2em;
}
.order{
  padding: 2em
}
</style>
